import { render, staticRenderFns } from "./ProfitlossExport.vue?vue&type=template&id=47110b72&"
import script from "./ProfitlossExport.vue?vue&type=script&lang=js&"
export * from "./ProfitlossExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports